module.exports = __webpack_public_path__ + "img/svnr_banner.4e93139b.jpg";